import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { SOURCE_CATALOGUE } from '../../store/constants';
import { bulkUpdateToList } from './bulkUpdateToList';
import { TFunction } from 'i18next';
import { BulkAddProductsToSelectionListResponse } from '../../store/api';
import { ProductMetaData } from '../../../models/Product';
import { addBulkFromCatalogueByIds, AddBulkFromCatalogueByIdsRequest } from './addBulkFromCatalogueByIds';

type GetRequestParams = {
    selectionListId: string;
    products: ReadonlyArray<ProductMetaData>;
    performChecks: boolean;
};
const buildAddProductsCallback = (
    { selectionListId, products, performChecks = true }: GetRequestParams,
    t: TFunction
): (() => Promise<BulkAddProductsToSelectionListResponse>) => {
    const productIds = products.map(product => product.id);
    return () => {
        try {
            const body: AddBulkFromCatalogueByIdsRequest = {
                productIds
            };

            return addBulkFromCatalogueByIds({
                selectionListId,
                body,
                params: {
                    performChecks
                }
            });
        } catch (e) {
            throw new Error(t('notifications.buildAddProductsCallback.error'));
        }
    };
};

export const useAddTopChartProductsToList = () => {
    const { t } = useTranslation();
    const dispatchRedux = useDispatch();
    const [isLoading, setLoading] = useState(false);

    return {
        isLoading,
        addToListBulk: (listId: string, products: ReadonlyArray<ProductMetaData>, performChecks: boolean) => {
            const apiCallback = buildAddProductsCallback(
                {
                    selectionListId: listId,
                    products,
                    performChecks
                },
                t
            );

            return bulkUpdateToList({
                dispatch: dispatchRedux,
                setLoading,
                performChecks,
                source: SOURCE_CATALOGUE,
                apiCallback,
                t
            });
        }
    };
};
